import { isProdEnv, isUatEnv } from "lib/routing";
import { unqiueElems } from "lib/utils";
import dictionary_en from "./dictionary_en.json";
import dictionary_ja from "./dictionary_ja.json"; // TODO via dynamic imports as required here

let language = null;

const dictionary = {
  en: dictionary_en,
  ja: dictionary_ja,
};

export const i18n = {
  translate: (key, noWarn) => dictionary[language][key] || onNotFound(key, noWarn),
  getLanguage: () => language,
  setLanguage: (newLanguage) => {
    language = dictionary[newLanguage] ? newLanguage : "ja";
  },
  addTranslations: (lang) => (translations) => {
    dictionary[lang] = { ...dictionary[lang], ...translations };
  },
};

const onNotFound = (key, noWarn) => {
  if (language === "en") return key;
  if (noWarn || isProdEnv || isUatEnv) return key;

  // eslint-disable-next-line no-console
  console.error(`Missing translation for key: "${key}" in dictionary_${language}`);

  window._i18nMiss = window._i18nMiss ? unqiueElems(window._i18nMiss.concat(key)) : [key];
  return `** No translation available for ${key} **`;
};

// shortcuts
export const _t = i18n.translate;
export const isJa = () => i18n.getLanguage() === "ja";
export const isEn = () => i18n.getLanguage() === "en";
export const _addEnDict = i18n.addTranslations("en");
export const _addJaDict = i18n.addTranslations("ja");
export const getUiLang = () => i18n.getLanguage();
